import {
  ConfirmationModalV2,
  IConfirmationModalV2Props,
} from 'components/ui/ConfirmationModal/ConfirmationModalV2';

export interface IConfirmationModalProps extends IConfirmationModalV2Props {}

const ConfirmationModal = ({ className, ...rest }: IConfirmationModalProps) => (
  <ConfirmationModalV2 className={className} {...rest} />
);

ConfirmationModal.Body = ConfirmationModalV2.Body;
ConfirmationModal.Confirmation = ConfirmationModalV2.Confirmation;
ConfirmationModal.Footer = ConfirmationModalV2.Footer;
ConfirmationModal.Header = ConfirmationModalV2.Header;
ConfirmationModal.Icon = ConfirmationModalV2.Icon;

export { ConfirmationModal };
